import { APIRoute } from '@/modules/utils'
import { HydraCollection } from 'emt-library'
import { ApiNotification } from '@/data'

export const Route: APIRoute = {
  method: 'GET',
  path: `/v2/customers/:customerId/notifications`,
}

export type UrlParams = {
  customerId: string
}

export type Response = HydraCollection<ApiNotification>
